import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import { ResponseError } from "./interfaces/api-error";
import { Environment } from "@coxauto-ui/cxm/communications/interfaces";
import {
  GetCommunicationAttachmentThumbnailRequest,
  GetCommunicationAttachmentThumbnailRequestV2
} from "./interfaces/get-communication-attachment-thumbnail";

export async function getCommunicationAttachmentThumbnail(
  data: GetCommunicationAttachmentThumbnailRequest,
  env: Environment
): Promise<ArrayBuffer | ResponseError> {
  const url = `${getBaseUrl(env)}CxM/attachment/id/thumbnail?ConsumerId=${
    data.consumerId
  }&CoxAutoMessageId=${data.coxAutoMessageId}&AttachmentId=${
    data.attachmentId
  }&ConsumerRecordSystem=${data.consumerRecordSystem}`;

  const header = await getHeader();

  const response = await fetchWrapper.getBinaryAsync(url, {
    ...header,
    "X-Signature": data.XSignature
  });

  if (response && response.data) {
    return response.data;
  } else {
    const error: ResponseError = {
      isError: true,
      statusCode: response.statusCode,
      errorResult: response.error
    };
    return error;
  }
}

export async function getCommunicationAttachmentThumbnailV2(
  data: GetCommunicationAttachmentThumbnailRequestV2,
  env: Environment
): Promise<ArrayBuffer | ResponseError> {
  const url = `${getBaseUrl(env)}CxM/attachment/id/thumbnail?CommunicationId=${
    data.communicationId
  }&AttachmentId=${data.attachmentId}&ConsumerId=${
    data.consumerId
  }&PresignedUrl=${encodeURIComponent(
    data.presignedUrl
  )}&Filename=${encodeURIComponent(
    data.filename
  )}&ContentType=${encodeURIComponent(data.contentType)}`;

  const header = await getHeader(2);

  const response = await fetchWrapper.getBinaryAsync(url, {
    ...header,
    "X-Signature": data.XSignature
  });

  if (response && response.data) {
    return response.data;
  } else {
    const error: ResponseError = {
      isError: true,
      statusCode: response.statusCode,
      errorResult: response.error
    };
    return error;
  }
}
